import './SLayout.css';

const SFooter = () => {
  return (
    <section className="footer align-items-center d-flex justify-content-center">
      <div className="text-white">
        &copy; 2021 Strides Premier Private Hire and Limousine Pte. Ltd. |{' '}
        <a
          href="https://stridespremier.com.sg/terms-of-use/"
          target="_blank"
          rel="noreferrer"
        >
          <u className="text-white">Terms of Use</u>
        </a>{' '}
        |{' '}
        <a
          href="https://stridespremier.com.sg/privacy-policy/"
          target="_blank"
          rel="noreferrer"
        >
          <u className="text-white">Privacy Policy</u>
        </a>
      </div>
    </section>
  );
};

export default SFooter;
